import { connect } from 'react-redux';

import { requestLogout } from '../../../store/authentication/thunks';
import SessionManager from './SessionManager';
import { extendSession } from './sessionControl';

interface StateFromProps {
  sessionTotalLength: number;
  sessionExpiry: string | null;
}

interface DispatchFromProps {
  requestLogout: () => void;
}

const mapStateToProps = (state: any) => ({
  // The session ttl configuration taken from the backend session.
  sessionTotalLength: state.authentication.sessionTotalLength,
  // The date/time that the current client session will expire.
  sessionExpiry: state.authentication.sessionExpiry,
});

const mapDispatchToProps = {
  extendSession,
  requestLogout,
};

const SessionManagerContainer = connect<StateFromProps, DispatchFromProps, void>(
  mapStateToProps,
  mapDispatchToProps,
)(SessionManager);

export default SessionManagerContainer;
